export default {"src":"/_next/static/media/li.de830c27.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};